export default "__VITE_ASSET__a2e75082__"